export type ReportsTab = 'attendance' | 'leaveUsage' | 'mobileCheckin' | 'punch' | 'overtime' | 'consolidated' | 'alerts';

export interface ReportFormState {
  fromDate: string;
  toDate: string;
  searchTerm: string;
}

export const validateReportFilters = (tab: ReportsTab, form: ReportFormState): string | null => {
  const from = form.fromDate ? new Date(form.fromDate) : null;
  const to = form.toDate ? new Date(form.toDate) : null;

  if ((from && Number.isNaN(from.getTime())) || (to && Number.isNaN(to.getTime()))) {
    return 'Please provide valid dates.';
  }

  if (from && to && from > to) {
    return 'From date cannot be later than To date.';
  }

  if (tab === 'mobileCheckin' && (!form.fromDate || !form.toDate)) {
    return 'From date and To date are required for mobile check-in report.';
  }

  if (tab === 'punch' && (!form.fromDate || !form.toDate)) {
    return 'From date and To date are required for punch report.';
  }

  if (tab === 'leaveUsage' && form.searchTerm.trim().length > 100) {
    return 'Search term should not exceed 100 characters.';
  }

  if (from && to) {
    const diffDays = (to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24);
    if ((tab === 'mobileCheckin' || tab === 'punch') && diffDays > 90) {
      return 'Date range cannot exceed 90 days for this report.';
    }
    if ((tab === 'attendance' || tab === 'overtime' || tab === 'consolidated' || tab === 'alerts') && diffDays > 366) {
      return 'Date range cannot exceed 366 days.';
    }
  }

  return null;
};
